import * as constAction from 'root/actionConstants';
import {Map, List} from 'immutable';

export default function reducer(state = List([{}]), action) {
  switch (action.type) {
    case constAction.USUARIOS_CASUALES_SET_STATE_BY_DOCUMENTO: {
      if (action.payload.result && action.payload.result.resultado)
        return state.set(
          action.payload.i,
          Map(action.payload.result.resultado),
        );
      else return state;
    }
    case constAction.USUARIOS_CASUALES_ADD_STATE: {
      if (action.payload.documento) {
        return state.push({
          documento: action.payload.documento,
          nombre: 'Acompañante',
        });
      }
      return state.push({});
    }
    case constAction.USUARIOS_CASUALES_REMOVE_STATE: {
      return state.delete(action.payload.index);
    }
    case constAction.USUARIOS_CASUALES_RESET_STATE: {
      return List([{}]);
    }
  }
  return state;
}



// WEBPACK FOOTER //
// src/modules/usuariosCasuales/reducer.js